module.exports = __webpack_public_path__ + "img/personal_recommendation.eae5f063.svg";